module.exports = __webpack_public_path__ + "img/01.29a1dfbf.png";